/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ooL7EhXDmFQWnW9sxtchhE
// Component: zRIUpVU0Cm8

import * as React from "react";

import {
  Flex as Flex__,
  SingleBooleanChoiceArg,
  StrictProps,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  hasVariant,
  renderPlasmicSlot,
  useDollarState,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import NavSeparator from "../../components/dashboard/NavSeparator"; // plasmic-import: cOUHQYmbvX/component
import TeamBilling from "../../components/dashboard/TeamBilling"; // plasmic-import: MtL6MGlBxoy/component
import TeamMemberList from "../../components/dashboard/TeamMemberList"; // plasmic-import: 3jXSiWKc1-/component
import TeamMemberListItem from "../../components/dashboard/TeamMemberListItem"; // plasmic-import: gdLJj97tYt/component
import MenuButton from "../../components/widgets/MenuButton"; // plasmic-import: h69wHrrKtL/component

import { useEnvironment } from "../plasmic_kit_pricing/PlasmicGlobalVariant__Environment"; // plasmic-import: hIjF9NLAUKG-/globalVariant

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_plasmic_kit_pricing_css from "../plasmic_kit_pricing/plasmic_plasmic_kit_pricing.module.css"; // plasmic-import: ehckhYnyDHgCBbV47m9bkf/projectcss
import plasmic_plasmic_kit_color_tokens_css from "../plasmic_kit_q_4_color_tokens/plasmic_plasmic_kit_q_4_color_tokens.module.css"; // plasmic-import: 95xp9cYcv7HrNWpFWWhbcv/projectcss
import projectcss from "../PP__plasmickit_dashboard.module.css"; // plasmic-import: ooL7EhXDmFQWnW9sxtchhE/projectcss
import plasmic_plasmic_kit_design_system_deprecated_css from "../PP__plasmickit_design_system.module.css"; // plasmic-import: tXkSR39sgCDWSitZxC5xFV/projectcss
import sty from "./PlasmicTeamSettings.module.css"; // plasmic-import: zRIUpVU0Cm8/css

createPlasmicElementProxy;

export type PlasmicTeamSettings__VariantMembers = {
  hideNewButton: "hideNewButton";
};
export type PlasmicTeamSettings__VariantsArgs = {
  hideNewButton?: SingleBooleanChoiceArg<"hideNewButton">;
};
type VariantPropType = keyof PlasmicTeamSettings__VariantsArgs;
export const PlasmicTeamSettings__VariantProps = new Array<VariantPropType>(
  "hideNewButton"
);

export type PlasmicTeamSettings__ArgsType = {
  teamName?: React.ReactNode;
  billingError?: React.ReactNode;
};
type ArgPropType = keyof PlasmicTeamSettings__ArgsType;
export const PlasmicTeamSettings__ArgProps = new Array<ArgPropType>(
  "teamName",
  "billingError"
);

export type PlasmicTeamSettings__OverridesType = {
  root?: Flex__<"div">;
  header?: Flex__<"header">;
  freeBox?: Flex__<"div">;
  teamMenuButton?: Flex__<typeof MenuButton>;
  memberList?: Flex__<typeof TeamMemberList>;
  navSeparator?: Flex__<typeof NavSeparator>;
  teamBilling?: Flex__<typeof TeamBilling>;
};

export interface DefaultTeamSettingsProps {
  teamName?: React.ReactNode;
  billingError?: React.ReactNode;
  hideNewButton?: SingleBooleanChoiceArg<"hideNewButton">;
  className?: string;
}

const $$ = {};

function PlasmicTeamSettings__RenderFunc(props: {
  variants: PlasmicTeamSettings__VariantsArgs;
  args: PlasmicTeamSettings__ArgsType;
  overrides: PlasmicTeamSettings__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "hideNewButton",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.hideNewButton,
      },
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs,
  });

  const globalVariants = ensureGlobalVariants({
    environment: useEnvironment(),
  });

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_plasmic_kit_design_system_deprecated_css.plasmic_tokens,
        plasmic_plasmic_kit_color_tokens_css.plasmic_tokens,
        plasmic_plasmic_kit_pricing_css.plasmic_tokens,
        sty.root,
        {
          [plasmic_plasmic_kit_pricing_css.global_environment_website]:
            hasVariant(globalVariants, "environment", "website"),
          [plasmic_plasmic_kit_pricing_css.global_environment_website]:
            hasVariant(globalVariants, "environment", "website"),
          [plasmic_plasmic_kit_pricing_css.global_environment_website]:
            hasVariant(globalVariants, "environment", "website"),
          [plasmic_plasmic_kit_pricing_css.global_environment_website]:
            hasVariant(globalVariants, "environment", "website"),
          [plasmic_plasmic_kit_pricing_css.global_environment_website]:
            hasVariant(globalVariants, "environment", "website"),
          [plasmic_plasmic_kit_pricing_css.global_environment_website]:
            hasVariant(globalVariants, "environment", "website"),
          [plasmic_plasmic_kit_pricing_css.global_environment_website]:
            hasVariant(globalVariants, "environment", "website"),
          [plasmic_plasmic_kit_pricing_css.global_environment_website]:
            hasVariant(globalVariants, "environment", "website"),
          [plasmic_plasmic_kit_pricing_css.global_environment_website]:
            hasVariant(globalVariants, "environment", "website"),
        }
      )}
    >
      <header
        data-plasmic-name={"header"}
        data-plasmic-override={overrides.header}
        className={classNames(projectcss.all, sty.header, {
          [sty.headerhideNewButton]: hasVariant(
            $state,
            "hideNewButton",
            "hideNewButton"
          ),
        })}
      >
        <div
          data-plasmic-name={"freeBox"}
          data-plasmic-override={overrides.freeBox}
          className={classNames(projectcss.all, sty.freeBox)}
        >
          {renderPlasmicSlot({
            defaultContents: "Team Name",
            value: args.teamName,
            className: classNames(sty.slotTargetTeamName),
          })}
        </div>
        <MenuButton
          data-plasmic-name={"teamMenuButton"}
          data-plasmic-override={overrides.teamMenuButton}
          className={classNames("__wab_instance", sty.teamMenuButton)}
        />
      </header>
      <TeamMemberList
        data-plasmic-name={"memberList"}
        data-plasmic-override={overrides.memberList}
        className={classNames("__wab_instance", sty.memberList, {
          [sty.memberListhideNewButton]: hasVariant(
            $state,
            "hideNewButton",
            "hideNewButton"
          ),
        })}
      >
        <TeamMemberListItem
          className={classNames(
            "__wab_instance",
            sty.teamMemberListItem__rdPmn
          )}
          name={"Kimmy Schmidt"}
        />

        <TeamMemberListItem
          className={classNames(
            "__wab_instance",
            sty.teamMemberListItem__nbSwk
          )}
          name={
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__ahUvf
              )}
            >
              {"Carl Sagan"}
            </div>
          }
        />

        <TeamMemberListItem
          className={classNames(
            "__wab_instance",
            sty.teamMemberListItem___9Njm9
          )}
          name={
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__dtMjE
              )}
            >
              {"Rosa Diaz"}
            </div>
          }
        />

        <TeamMemberListItem
          className={classNames(
            "__wab_instance",
            sty.teamMemberListItem__ngOos
          )}
          name={
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__iTfFq
              )}
            >
              {"Jared Dunn"}
            </div>
          }
        />
      </TeamMemberList>
      <NavSeparator
        data-plasmic-name={"navSeparator"}
        data-plasmic-override={overrides.navSeparator}
        className={classNames("__wab_instance", sty.navSeparator)}
        noPadding={true}
      />

      <TeamBilling
        data-plasmic-name={"teamBilling"}
        data-plasmic-override={overrides.teamBilling}
        billingError={renderPlasmicSlot({
          defaultContents: "ERROR: Cannot process payment",
          value: args.billingError,
        })}
        className={classNames("__wab_instance", sty.teamBilling, {
          [sty.teamBillinghideNewButton]: hasVariant(
            $state,
            "hideNewButton",
            "hideNewButton"
          ),
        })}
        currentBill={"$45 /month"}
        tier={"free"}
      />
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: [
    "root",
    "header",
    "freeBox",
    "teamMenuButton",
    "memberList",
    "navSeparator",
    "teamBilling",
  ],
  header: ["header", "freeBox", "teamMenuButton"],
  freeBox: ["freeBox"],
  teamMenuButton: ["teamMenuButton"],
  memberList: ["memberList"],
  navSeparator: ["navSeparator"],
  teamBilling: ["teamBilling"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
  header: "header";
  freeBox: "div";
  teamMenuButton: typeof MenuButton;
  memberList: typeof TeamMemberList;
  navSeparator: typeof NavSeparator;
  teamBilling: typeof TeamBilling;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicTeamSettings__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicTeamSettings__VariantsArgs;
    args?: PlasmicTeamSettings__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicTeamSettings__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicTeamSettings__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTeamSettings__ArgProps,
          internalVariantPropNames: PlasmicTeamSettings__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicTeamSettings__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicTeamSettings";
  } else {
    func.displayName = `PlasmicTeamSettings.${nodeName}`;
  }
  return func;
}

export const PlasmicTeamSettings = Object.assign(
  // Top-level PlasmicTeamSettings renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    header: makeNodeComponent("header"),
    freeBox: makeNodeComponent("freeBox"),
    teamMenuButton: makeNodeComponent("teamMenuButton"),
    memberList: makeNodeComponent("memberList"),
    navSeparator: makeNodeComponent("navSeparator"),
    teamBilling: makeNodeComponent("teamBilling"),

    // Metadata about props expected for PlasmicTeamSettings
    internalVariantProps: PlasmicTeamSettings__VariantProps,
    internalArgProps: PlasmicTeamSettings__ArgProps,
  }
);

export default PlasmicTeamSettings;
/* prettier-ignore-end */
